/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { HOME_TODAY_SCREEN, SAMPLE_TO_SALE_SCREEN, COMMON, API_CONSTANTS, ALL_ROUTES } from '../../global/Constants';
import './sample-to-sale.css';
import Header from '../common/Header';
import { HeaderTypes, S2S_CROP, S2S_STAGE, CROP_GROUP } from "../../global/Enum";
import DesktopFooter from '../common/DesktopFooter';
import Loader from "../common/loader/Loader";
import SowingTransplantationView from './SowingTransplantationView';
import TransplantationView from './TransplantationView';
import PlotVisitView from './PlotVisitView';
import FieldDayView from './FieldDayView';
import HarvestCottonView from './HarvestCottonView';
import HarvestRiceView from './HarvestRiceView';
import HarvestMilletView from './HarvestMilletView';
import FieldDamageView from './FieldDamageView';
import GerminationView from './GerminationView';
import FruitQualityView from './FruitQualityView';
import PestDiseaseView from './PestDiseaseView';

import SyncLoader from '../common/loader/SyncLoader';
import Utilities from '../../global/Utilities';
import SyncServices from '../../providers/SyncServices';
import DataProvider from '../../providers/DataProvider';


class ActivityHistoryPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStage: S2S_STAGE.SOWING_AND_TRANSPLANTATION,
            isLoading: false,
            krishakInfo: { name: "", phone: "" },
            activity: null,
            sowingStage: null,
            transplantationStage: null,
            plotVisitStage: null,
            fieldDayStage: null,
            harvestDetailStage: null,
            fieldDamageStage: null,
            germinationStage: null,
            fruitQualityStage: null,
            pestDiseaseStage: null,

            // fieldDamageStage: {
            //     fieldDamage: "Yes",
            //     damageDueTo: "Low Maintenance",
            //     remark: "Field Damage Stage",
            //     images: ["../assets/images/krishak-info-img1.png", "../assets/images/krishak-info-img2.png"],
            // },
        }
    }

    componentDidMount() {
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state !== undefined) {
                const activity = this.props.location.state.activity;

                Utilities.LogPrint("History Data:-->", activity);
                if (activity !== undefined && activity !== null) {
                    const data = activity?.data;
                    this.setState({
                        activity: activity,
                        sowingStage: data?.history?.stage_one?.[0],
                        transplantationStage: data?.history?.stage_two?.[0],
                        plotVisitStage: data?.history?.stage_three,
                        fieldDayStage: data?.history?.stage_four?.[0],
                        harvestDetailStage: data?.history?.stage_five,
                        fieldDamageStage: data?.history?.stage_six?.[0],
                        germinationStage: data?.history?.stage_eight?.[0],
                        fruitQualityStage: data?.history?.stage_nine?.[0],
                        pestDiseaseStage: data?.history?.stage_ten?.[0],
                    });
                    //this.getActivityById(activity.key);
                    this.getKrishakById(activity.krishak_id);
                }
            } else {
                this.props.history.replace(ALL_ROUTES.HOME_TODAY_ROUTE);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE)
        }
    }

    checkVegCrops = () => {
        const { activity } = this.state;
        const crop = DataProvider.getInstance().getCropById(activity?.crop_id);
        //Utilities.LogPrint("Crop", crop);
        if (crop?.crop_group_id === CROP_GROUP.VEGETABLE_CROPS) {
            return true;
        } else {
            return false;
        }
    }

    // getActivityById(activityId) {
    //     this.setState({ isLoading: true });

    //     SyncServices.getActivityById("key", activityId).then(activity => {
    //         Utilities.LogPrint("getActivityById ===========", activity);
    //         const data = activity?.data;
    //         this.setState({
    //             //data: activity,
    //             sowingStage: data?.history?.stage_one?.[0],
    //             transplantationStage: data?.history?.stage_two?.[0],
    //             plotVisitStage: data?.history?.stage_three,
    //             fieldDayStage: data?.history?.stage_four?.[0],
    //             harvestDetailStage: data?.history?.stage_five,
    //             fieldDamageStage: data?.history?.stage_six?.[0],
    //             isLoading: false,
    //         });
    //     });
    // }

    getKrishakById = (krishak_id) => {
        //Utilities.LogPrint("krishak_id", krishak_id);
        SyncServices.findKrishakFromDatabase("krishak_id", String(krishak_id)).then(data => {
            if (data) {
                //Utilities.LogPrint("getKrishakFromDatabase", data);
                if (data.is_active === undefined || data.is_active === null || data.is_active === 1) {
                    //const krishakInfo = data;
                    let krishak = { name: data.name, phone: data.phone }
                    this.setState({
                        krishakInfo: krishak
                    });
                } else {
                    //this.checkKrishakOffline(krishak_id);
                }
            } else {
                //Utilities.LogPrint("getKrishakFromDatabase", "no");
                //this.checkKrishakOffline(krishak_id);
            }
        });
    }

    handleChangeTab = (type) => {
        Utilities.LogPrint("Type", type);
        this.setState({
            activeStage: type,
        });
    }


    _handleBack = () => {
        this.props.history.goBack();
    }

    handleSyncLoading = (loading, tableName) => {
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isSyncLoading, tableName } = this.state;
        const { isLoading, activity, activeStage, sowingStage, transplantationStage, plotVisitStage, fieldDayStage, harvestDetailStage, krishakInfo, fieldDamageStage,
            germinationStage, fruitQualityStage, pestDiseaseStage } = this.state;
        return (
            <div>
                <Header selectedTab={HeaderTypes.TODAY} handleSyncLoading={this.handleSyncLoading} />

                <div className="container pt-35 pb-3">
                    <div className="row">
                        <div className="col-xl-6 col-lg-7 col-md-9 col-12">
                            <div className="activity-info-box green-activity mb-3 text-white max-w-460">
                                <span>{activity?.activity_tag}</span>
                                <h5>{HOME_TODAY_SCREEN.SAMPLE_TO_SALE} - {SAMPLE_TO_SALE_SCREEN.ACTIVITY_HISTORY}</h5>
                                <span>{activity?.crop_name + ", " + activity?.hybrid_name + " | " + activity?.village_name}</span>
                            </div>

                        </div>
                        <div className="col-xl-6 col-lg-5 col-md-3 d-md-flex back-btn d-none">
                            <button className="btn btn-secondary min-w-182 krishak-cancel-btn" onClick={() => this._handleBack()}>{COMMON.BACK}</button>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 krishak-info ">
                            <div className="row">
                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="row mb-3">
                                        <div className="col-lg-12 col-4 mb-md-2">
                                            {HOME_TODAY_SCREEN.FARMER}
                                        </div>
                                        <div className="col-lg-12 col-8">
                                            <span className="d-block font-weight-medium">{krishakInfo?.name}</span>
                                            <span className="d-block font-weight-medium">{`+91 ${krishakInfo?.phone}`}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 col-12 d-none">
                                    <div className="row mb-3">
                                        <div className="col-lg-12 col-4 mb-md-2">
                                            {COMMON.LOCATION}
                                        </div>
                                        <div className="col-lg-12 col-8">
                                            <span className="d-block font-weight-medium">Unnamed Road, Amargarh, Haryana 126116, India</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Tabs Details */}
                            <div className="row">
                                <div className="col-lg-4 mb-md-3">
                                    <ul className="general-info-menu">
                                        <li className={activeStage === S2S_STAGE.SOWING ? 'active' : ''} data-tab="showingDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.SOWING_AND_TRANSPLANTATION) }}>{SAMPLE_TO_SALE_SCREEN.SOWING} <i className="customic ic-go-button ml-auto"></i></li>
                                        <li className={activeStage === S2S_STAGE.TRANSPLANTATION ? 'active' : '' || (transplantationStage === undefined || transplantationStage === null ? 'd-none' : '')} data-tab="transplantationDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.TRANSPLANTATION) }}>{SAMPLE_TO_SALE_SCREEN.TRANSPLANTATION} <i className="customic ic-go-button ml-auto"></i></li>
                                        <li className={activeStage === S2S_STAGE.GERMINATION ? 'active' : '' || (germinationStage === undefined || germinationStage === null ? 'd-none' : '')} data-tab="germinationDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.GERMINATION) }}>{SAMPLE_TO_SALE_SCREEN.GERMINATION} <i className="customic ic-go-button ml-auto"></i></li>
                                        <li className={activeStage === S2S_STAGE.FRUIT_QUALITY ? 'active' : '' || (fruitQualityStage === undefined || fruitQualityStage === null ? 'd-none' : '')} data-tab="fruitQualityDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.FRUIT_QUALITY) }}>{SAMPLE_TO_SALE_SCREEN.FRUIT_QUALITY} <i className="customic ic-go-button ml-auto"></i></li>
                                        <li className={activeStage === S2S_STAGE.PEST_AND_DISEASE ? 'active' : '' || (pestDiseaseStage === undefined || pestDiseaseStage === null ? 'd-none' : '')} data-tab="pestDiseaseDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.PEST_AND_DISEASE) }}>{SAMPLE_TO_SALE_SCREEN.PEST_AND_DISEASE} <i className="customic ic-go-button ml-auto"></i></li>
                                        <li className={activeStage === S2S_STAGE.PLOT_VISIT ? 'active' : '' || (plotVisitStage === undefined || plotVisitStage === null ? 'd-none' : '')} data-tab="plotDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.PLOT_VISIT) }}>{SAMPLE_TO_SALE_SCREEN.PLOT_VISIT} <i className="customic ic-go-button ml-auto"></i></li>
                                        <li className={activeStage === S2S_STAGE.FIELD_DAY ? 'active' : '' || (fieldDayStage === undefined || fieldDayStage === null ? 'd-none' : '')} data-tab="fieldDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.FIELD_DAY) }}>{SAMPLE_TO_SALE_SCREEN.FIELD_DAY}<i className="customic ic-go-button ml-auto"></i></li>
                                        <li className={activeStage === S2S_STAGE.HARVEST_DETAILS ? 'active' : '' || (harvestDetailStage === undefined && harvestDetailStage !== null ? 'd-none' : '')} data-tab="harvestDetails" onClick={() => { this.handleChangeTab(S2S_STAGE.HARVEST_DETAILS) }}>{SAMPLE_TO_SALE_SCREEN.HARVEST_DETAILS} <i className="customic ic-go-button ml-auto"></i></li>
                                        <li className={activeStage === S2S_STAGE.FIELD_DAMAGE ? 'active' : '' || (fieldDamageStage === null || fieldDamageStage === undefined ? 'd-none' : '')} data-tab="fieldDamage" onClick={() => { this.handleChangeTab(S2S_STAGE.FIELD_DAMAGE) }}>{SAMPLE_TO_SALE_SCREEN.FIELD_DAMAGE} <i className="customic ic-go-button ml-auto"></i></li>
                                    </ul>
                                </div>

                                <div className="col-lg-8" id="generalInfoForm">
                                    <div className="accordion">

                                        {/* Sowing and Transplantation */}
                                        <div id="showingDetailsHeading" className="d-md-none accordion-heading">
                                            <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#showingDetails" aria-expanded="false" aria-controls="showingDetails" >
                                                {SAMPLE_TO_SALE_SCREEN.SOWING}
                                                <i className="customic ic-down-arrow ml-auto"></i>
                                            </a>
                                        </div>
                                        <div id="showingDetails" className={`collapse ${activeStage === S2S_STAGE.SOWING ? "accordion-body show " : ""}`} aria-labelledby="showingDetailsHeading" data-parent="#generalInfoForm">
                                            <SowingTransplantationView sowingStage={sowingStage} isVegCrop={this.checkVegCrops()} />
                                        </div>

                                        {/* Transplantation */}
                                        {transplantationStage !== undefined && transplantationStage !== null ?
                                            <div>
                                                <div id="transplantationDetailsHeading" className="d-md-none accordion-heading">
                                                    <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#transplantationDetails" aria-expanded="false" aria-controls="transplantationDetails" >
                                                        {SAMPLE_TO_SALE_SCREEN.TRANSPLANTATION}
                                                        <i className="customic ic-down-arrow ml-auto"></i>
                                                    </a>
                                                </div>
                                                <div id="transplantationDetails" className={`collapse ${activeStage === S2S_STAGE.TRANSPLANTATION ? 'show accordion-body' : ''}`} aria-labelledby="transplantationDetailsHeading" data-parent="#generalInfoForm">
                                                    <TransplantationView transplantationStage={transplantationStage} isVegCrop={this.checkVegCrops()} />
                                                </div>
                                            </div> : null
                                        }

                                        {/* Germination */}
                                        {germinationStage !== undefined && germinationStage !== null ?
                                            <div>
                                                <div id="germinationHeading" className="d-md-none accordion-heading">
                                                    <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#germinationDetails" aria-expanded="false" aria-controls="germinationDetails" >
                                                        {SAMPLE_TO_SALE_SCREEN.GERMINATION}
                                                        <i className="customic ic-down-arrow ml-auto"></i>
                                                    </a>
                                                </div>
                                                <div id="germinationDetails" className={`collapse ${activeStage === S2S_STAGE.GERMINATION ? 'show accordion-body' : ''}`} aria-labelledby="germinationHeading" data-parent="#generalInfoForm">
                                                    <GerminationView germinationStage={germinationStage} />
                                                </div>
                                            </div> : null
                                        }

                                        {/* Fruit Quality */}
                                        {fruitQualityStage !== undefined && fruitQualityStage !== null ?
                                            <div>
                                                <div id="fruitQualityHeading" className="d-md-none accordion-heading">
                                                    <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#fruitQualityDetails" aria-expanded="false" aria-controls="fruitQualityDetails" >
                                                        {SAMPLE_TO_SALE_SCREEN.FRUIT_QUALITY}
                                                        <i className="customic ic-down-arrow ml-auto"></i>
                                                    </a>
                                                </div>
                                                <div id="fruitQualityDetails" className={`collapse ${activeStage === S2S_STAGE.FRUIT_QUALITY ? 'show accordion-body' : ''}`} aria-labelledby="fruitQualityHeading" data-parent="#generalInfoForm">
                                                    <FruitQualityView fruitQualityStage={fruitQualityStage} />
                                                </div>
                                            </div> : null
                                        }

                                        {/* Pest & Disease */}
                                        {pestDiseaseStage !== undefined && pestDiseaseStage !== null ?
                                            <div>
                                                <div id="pestDiseaseHeading" className="d-md-none accordion-heading">
                                                    <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#pestDiseaseDetails" aria-expanded="false" aria-controls="pestDiseaseDetails" >
                                                        {SAMPLE_TO_SALE_SCREEN.PEST_AND_DISEASE}
                                                        <i className="customic ic-down-arrow ml-auto"></i>
                                                    </a>
                                                </div>
                                                <div id="pestDiseaseDetails" className={`collapse ${activeStage === S2S_STAGE.PEST_AND_DISEASE ? 'show accordion-body' : ''}`} aria-labelledby="pestDiseaseHeading" data-parent="#generalInfoForm">
                                                    <PestDiseaseView pestDiseaseStage={pestDiseaseStage} />
                                                </div>
                                            </div> : null
                                        }


                                        {/* Plot Visit */}
                                        {plotVisitStage !== undefined && plotVisitStage !== null ?
                                            <div>
                                                <div id="plotDetailsHeading" className="d-md-none accordion-heading">
                                                    <a href="" data-toggle="collapse" data-target="#plotDetails" aria-expanded="false" aria-controls="plotDetails" className="font-weight-medium d-flex w-100 align-items-center my-3" >
                                                        {SAMPLE_TO_SALE_SCREEN.PLOT_VISIT}
                                                        <i className="customic ic-down-arrow ml-auto"></i>
                                                    </a>
                                                </div>
                                                <div id="plotDetails" className={`collapse ${activeStage === S2S_STAGE.PLOT_VISIT ? "accordion-body show " : ""}`} aria-labelledby="plotDetailsHeading" data-parent="#generalInfoForm">
                                                    <PlotVisitView plotVisitStage={plotVisitStage} />
                                                </div>
                                            </div> : null
                                        }


                                        {/* Field Day */}
                                        {fieldDayStage !== undefined && fieldDayStage !== null ?
                                            <div>
                                                <div id="fieldDetailsHeading" className="d-md-none accordion-heading">
                                                    <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3 bold" data-toggle="collapse" data-target="#fieldDetails" aria-expanded="false" aria-controls="fieldDetails">
                                                        {SAMPLE_TO_SALE_SCREEN.FIELD_DAY}
                                                        <i className="customic ic-down-arrow ml-auto"></i>
                                                    </a>
                                                </div>
                                                <div id="fieldDetails" className={`collapse ${activeStage === S2S_STAGE.FIELD_DAY ? "accordion-body show " : ""}`} aria-labelledby="fieldDetailsHeading" data-parent="#generalInfoForm">
                                                    <FieldDayView fieldDayStage={fieldDayStage} />
                                                </div>
                                            </div> : null
                                        }

                                        {/* Harvest Details */}
                                        {harvestDetailStage !== undefined && harvestDetailStage !== null ? <div>
                                            <div id="harvestDetailsHeading" className="d-md-none accordion-heading">
                                                <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#harvestDetails" aria-expanded="false" aria-controls="harvestDetails">
                                                    {SAMPLE_TO_SALE_SCREEN.HARVEST_DETAILS}
                                                    <i className="customic ic-down-arrow ml-auto"></i>
                                                </a>
                                            </div>

                                            <div id="harvestDetails" className={`collapse ${activeStage === S2S_STAGE.HARVEST_DETAILS ? "accordion-body show " : ""}`} aria-labelledby="harvestDetailsHeading" data-parent="#generalInfoForm">
                                                {/* <HarvestDetailsView harvestDetailStage={harvestDetailStage} /> */}
                                                {activity?.crop_name === S2S_CROP.COTTON ?
                                                    <HarvestCottonView harvestDetailStage={harvestDetailStage}
                                                        hybridName={activity?.hybrid_name} /> : null
                                                }

                                                {activity?.crop_name === S2S_CROP.RICE ?
                                                    <HarvestRiceView harvestDetailStage={harvestDetailStage}
                                                        hybridName={activity?.hybrid_name} /> : null
                                                }

                                                {activity?.crop_name === S2S_CROP.MILLET || activity?.crop_name === S2S_CROP.MUSTARD ?
                                                    <HarvestMilletView harvestDetailStage={harvestDetailStage}
                                                        hybridName={activity?.hybrid_name} /> : null
                                                }
                                            </div>
                                        </div> : null
                                        }


                                        {/* Field Damage */}
                                        {fieldDamageStage !== undefined && fieldDamageStage !== null ? <div>
                                            <div id="fieldDamageHeading" className="d-md-none accordion-heading">
                                                <a href="" className="font-weight-medium d-flex w-100 align-items-center my-3" data-toggle="collapse" data-target="#fieldDamage" aria-expanded="false" aria-controls="fieldDamage">
                                                    {SAMPLE_TO_SALE_SCREEN.FIELD_DAMAGE}
                                                    <i className="customic ic-down-arrow ml-auto"></i>
                                                </a>
                                            </div>

                                            <div id="fieldDamage" className="collapse accordion-body" aria-labelledby="fieldDamageHeading" data-parent="#generalInfoForm">
                                                <FieldDamageView fieldDamageStage={fieldDamageStage} />
                                            </div>
                                        </div> : null
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 d-flex">
                            <button className="btn btn-primary w-100 d-lg-none" onClick={this._handleBack}>{COMMON.BACK}</button>
                        </div>
                    </div>
                </div>
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
                <DesktopFooter />
                {isLoading ? <Loader /> : null}
            </div>
        )
    }

}

export default withRouter(ActivityHistoryPage);